export * from "@buf/evmos_evmos.bufbuild_es/evmos/vesting/v2/tx_pb.js";
//# sourceMappingURL=tx.js.map